import React, { useState, useRef, useEffect } from "react";
import { useFormik } from 'formik';
import validate from '../../assests/js/validate';
import { useDispatch, useSelector } from "react-redux";
import { setIsWidth } from '../../store/slice/currentStageSlice';
import { currentStageData } from '../../store/slice/currentStageSlice';
import GisApiServices from "../../services/GisApiServices";
import { useNavigate } from "react-router-dom";
function Settings() {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(null);
  const [sliderStyle, setSliderStyle] = useState({ left: 0, width: 0 });
  const switchDivRef = useRef(null);
  const { isTheme } = useSelector((state) => state.currentStage)
  const authData = useSelector(state => state.authToken.authData);
  const [isGetPermission, setIsGetPermission] = useState([]);
  const tabs = [
    {
      id: "tab1",
      label: "System Preferences",
      content: <SystenPreference />,
      activeImage: "img/active-settings.svg",
      inactiveImage: isTheme === 'light' ? "img/sysrefdelight.svg" : "img/deactive-settings.svg",
      activityId: 'S1'
    },
    // {
    //   id: "tab2",
    //   label: "API Management",
    //   content: <ApiManagememt />,
    //   activeImage: "img/active-api.svg",
    //   inactiveImage: isTheme === 'light' ? "img/apidelight.svg" : "img/deactive-api.svg",
    //   activityId: 'S2'
    // },
    {
      id: "tab3",
      label: "Integration Details",
      content: <IntegrationManagement />,
      activeImage: "img/active-integration.svg",
      inactiveImage: isTheme === 'light' ? "img/integrationdelight.svg" : "img/deactive-integration.svg",
      activityId: 'S3'
    },
  ];

  useEffect(() => {
    dispatch(setIsWidth(false))
    dispatch(currentStageData(''))
    const updateSlider = () => {
      const activeElement = switchDivRef.current.querySelector(".active-tab-act");
      if (activeElement) {
        const { offsetLeft: left, offsetWidth: width } = activeElement;
        setSliderStyle({ left, width });
      }
    };

    updateSlider();
    window.addEventListener("resize", updateSlider);

    return () => {
      window.removeEventListener("resize", updateSlider);
    };
  }, [activeTab]);


  const fetchUserPermission = async () => {
    try {
      const authToken = localStorage.getItem('token');
      if (!authToken) {
        console.error("No auth token found");
        navigate("/login");
        return;
      }

      const value = {
        role_Id: authData?.RoleID
      }
      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };
      const response = await GisApiServices.userPermissions(value, config);
      const getPermission = response.data?.data || [];
      console.log("data12141", getPermission?.permissions)
      setIsGetPermission(getPermission?.permissions)
    } catch (error) {
      console.error("Error fetching user roles", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchUserPermission()
  }, [])

  const filteredTabs = tabs.filter(tab =>
    isGetPermission.some(permission => permission.activityId === tab.activityId)
  );


  useEffect(() => {
    if (filteredTabs.length > 0 && !filteredTabs.some(tab => tab.id === activeTab)) {
      setActiveTab(filteredTabs[0].id);
    }
  }, [filteredTabs]);


  return (
    <>
      {/* <div className='filterdiv'>
        <div className='row gx-0'>
          <div className='col-lg-6 col-md-12'>
            <div className='fildiv' style={{ gap: "12px" }}>
              <div className='search-container1'>
                <input
                  className='access-search'
                  placeholder='Search activity'
                />

                <span className='search-img'>

                  {isTheme === "light" ? <img src="img/bluesearch.svg" alt='search' /> :
                    <img src="img/Vectorsearch.png" alt='search' />}

                </span>
              </div>
              <button className='filter-btn'>Filter
              </button>
              <button className='filter-btn'>Sort</button>
            </div>
          </div>
        </div>
      </div> */}

      <div className="switch-tabs">
        {/* Tab Buttons */}
        <div className="switchdivact" ref={switchDivRef}>
          {filteredTabs.map((tab) => (
            <div
              type="button"
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`btn-access-switch ${activeTab === tab.id ? "active-tab-act" : ""}`}
            >
              <img
                src={activeTab === tab.id ? tab.activeImage : tab.inactiveImage}
                alt={tab.label}
                className="tab-icon"
              />
              <span>{tab.label}</span>
            </div>
          ))}
          <div
            className="acitveslider"
            style={{ ...sliderStyle, transition: "all 0.3s ease" }}
          ></div>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {filteredTabs.map(
            (tab) =>
              activeTab === tab.id && (
                <div key={tab.id} className="tab-panel">
                  {tab.content}
                </div>
              )
          )}
        </div>
      </div>

    </>
  )
}

const SystenPreference = () => {
  return (
    <div className="apimanagemenentdiv">
      <div className='row px-2'>
        <div className='col-xl-9 col-lg-12  auth-cotaniner disabled-card' >
          <div className='row align-items-center' style={{ rowGap: "12px" }}>
            <div className='col-md-9'>
              <div className='authleftdiv'>
                <h6>Language</h6>
                <p className='m-0'>Choose your preferred language to customize the app experience. Changing the language will update all text, labels, and notifications across the platform.</p>
              </div>
            </div>
            <div className='col-md-3 systemdropdown'>
              <select className="system-select">
                <option>English  Language</option>
                <option>Hindi Language</option>
              </select>
            </div>
          </div>
        </div>
        <div className='col-xl-9 col-lg-12  auth-cotaniner mt-3 disabled-card' >
          <div className='row align-items-center' style={{ rowGap: "12px" }}>
            <div className='col-md-8'>
              <div className='authleftdiv'>
                <h6>Timezone</h6>
                <p className='m-0'>Set your preferred timezone to ensure accurate timestamps for events, notifications, and other activities across the platform.</p>
              </div>
            </div>
            <div className='col-md-4 systemdropdown'>
              <select className="system-select">
                <option>Indian Standard Time (IST)</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      {/* <button className="role-active px-5 mt-4">Save Changes</button> */}
    </div>
  )
}


const ApiManagememt = () => {
  const { isTheme } = useSelector((state) => state.currentStage)
  return (
    <div className="apimanagemenentdiv">
      <h2 className="tab-text">Manage your API keys and access settings to integrate and interact with our platform securely. Use the API to connect your
        <br />
        applications and automate workflows.</h2>
      <div className="table-responsive mt-3">
        <table className="table table-dark-security caption-top manage-user-table">
          <thead>
            <tr>
              <th scope="col" className="text-start">API name</th>
              <th scope="col">Access Key</th>
              <th scope="col">Rate Limit</th>
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-start">
                Urban Data Access API
              </td>
              <td>XXXXXXXXXXXX</td>
              <td>1000 req/min</td>
              <td>Active</td>
              <td >
                <div className='checkboxsetting justify-content-center'>
                  <div type="button" data-bs-toggle="modal" data-bs-target="#editUserModal">
                    {isTheme === 'light' ? <img src="img/pencil-light.svg" alt='pencil' /> :
                      <img src="img/pencil.svg" alt='pencil' />}
                  </div>
                  <div type="button">
                    {isTheme === 'light' ? <img src="img/trash-bin-light.svg" alt='delete' /> :
                      <img src="img/trashbin.svg" alt='delete' />}
                  </div>
                  <label className="toggle-switch">
                    <input type="checkbox" />
                    <span className="slider"></span>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td className="text-start">
                Environmental API
              </td>
              <td>YYYYYYYYYYYY</td>
              <td>500 req/min</td>
              <td>Disabled</td>
              <td >
                <div className='checkboxsetting justify-content-center'>
                  <div type="button" data-bs-toggle="modal" data-bs-target="#editUserModal">
                    {isTheme === 'light' ? <img src="img/pencil-light.svg" alt='pencil' /> :
                      <img src="img/pencil.svg" alt='pencil' />}
                  </div>
                  <div type="button">
                    {isTheme === 'light' ? <img src="img/trash-bin-light.svg" alt='delete' /> :
                      <img src="img/trashbin.svg" alt='delete' />}
                  </div>
                  <label className="toggle-switch">
                    <input type="checkbox" />
                    <span className="slider"></span>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

const IntegrationManagement = () => {
  const { isTheme } = useSelector((state) => state.currentStage)
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      role: '',
    },
    validate,
    onSubmit: values => {
      console.log("data", JSON.stringify(values, null, 2))
    },
  });
  return (
    <div className="apimanagemenentdiv">
      <h6 className="tab-text">
        Seamlessly connect third-party applications and tools with our platform to enhance your workflows and automate processes.
        <br />
        Manage your integrations from one place with complete control over access and settings.
      </h6>
      <div className="row" style={{ rowGap: "20px" }}>
        <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
          <div className="integrationcard">
            <h6>ArcGIS Integration</h6>
            <div className="row">
              <div className="col-md-8">
                <div className="integrationstatus">
                  <h6 className="status">Status</h6>
                  <h6 className="active">Active</h6>
                </div>
                <div className="integrationstatus">
                  <h6 className="status">Date Active</h6>
                  <h6>25-02-25</h6>
                </div>
              </div>
            </div>
            {/* <hr /> */}
            {/* <div className="integrationcardfooter">
              <button className="btn-settings">Settings</button>
              <button className="btn-disconnect">Disconnect</button>
            </div> */}
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
          <div className="integrationcard">
            <h6>AI Module Integration</h6>
            <div className="row">
              <div className="col-md-8">
                <div className="integrationstatus">
                  <h6 className="status">Status</h6>
                  <h6 className="active">Active</h6>
                  {/* <h6 className="disabled">Active</h6> */}
                </div>
                <div className="integrationstatus">
                  <h6 className="status">Date Active</h6>
                  <h6>25-02-25</h6>
                </div>
              </div>
            </div>
            {/* <hr />
            <div className="integrationcardfooter">
              <button className="btn-settings">Settings</button>
              <button className="btn-disconnect">Disconnect</button>
            </div> */}
          </div>
        </div>
        {/* <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
          <div className="integrationcard">
            <div className="text-center py-4 my-2">
              <button className="add-btn" data-bs-toggle="modal" data-bs-target="#editUserModal">
                {isTheme === "light" ? <img src="img/add-light.svg" alt="add" /> :
                  <img src="img/addapi.svg" alt="add" />}
              </button>
              <h5 className="addnewintegrationtitle">Add new Integration</h5>
            </div>
          </div>
        </div> */}
      </div>
      {/* <div className="table-responsive mt-3">
        <table className="table table-dark-security caption-top manage-user-table">
          <thead>
            <tr>
              <th scope="col" className="text-start">Integration Name</th>
              <th scope="col">Last Sync Time</th>
              <th scope="col">Status</th>
              <th scope="col">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-start">
                ArcGIS Data Integration
              </td>
              <td>Nov 12, 2024</td>
              <td>Success</td>
              <td>View Log</td>
            </tr>
            <tr>
              <td className="text-start">
                IOT Sensors Integration
              </td>
              <td>Nov 12, 2024</td>
              <td>Failed</td>
              <td>Retry</td>
            </tr>
          </tbody>
        </table>
      </div> */}


      <div className="modal fade" id="editUserModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered addusermodal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Add new Integration</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                <img src="img/closebtn.svg" alt='img' width="20px" height="20px" />
              </button>
            </div>
            <div className="modal-body p-0">
              <form onSubmit={formik.handleSubmit}>
                <div>
                  <div className='wardanalysis'>
                    <div className="select">
                      <select
                        // id="role"
                        name="role"
                        onChange={formik.handleChange}
                        value={formik.values.role}
                        id="wardselect"
                      >
                        <option value="">Select available Platformt</option>
                        <option value="admin">ArcGIS Integration</option>
                        <option value="sub-admin">Google Maps</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  <input
                    id="name"
                    name="name"
                    type="text"
                    className='form-control'
                    onChange={formik.handleChange}
                    placeholder='Input API Key'
                    value={formik.values.firstName}
                  />
                  {formik.errors.firstName ? <div>{formik.errors.firstName}</div> : null}
                </div>

                <div className='row justify-content-between mt-4' style={{ rowGap: "20px" }}>
                  <div className='col-md-5'>
                    <button type="button" className="btn-cancel" data-bs-dismiss="modal" aria-label="Close">
                      Cancel
                    </button>
                  </div>
                  <div className='col-md-5'>
                    <button type="submit" className='btn btn-modal-submit w-100'>Save</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Settings